
import trust from "../assets/logo/trust-pilot.svg";
import truststars from "../assets/logo/trustpilotstarsfr.svg";
import { SITE_INFO } from "../configs/info";
import heroBg from "../assets/BG HERO.jpg";

export default function Home() {
  return (
    <>
      <section
        className="hero-section py-12 pt-24 md:py-6 md:pt-16 lg:pt-20 relative bg-black"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Boules de feu animées */}
        {[...Array(15)].map((_, i) => (
          <div key={i} className="fire-particle"></div>
        ))}
        <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
          <div className="mb-6 sm:mb-8 md:mb-3 mt-4 md:mt-2 lg:mt-3 flex flex-col items-start">
            <img
              src={trust}
              alt="trustpilot"
              className="w-28 sm:w-36 md:w-24 lg:w-32 h-auto mb-2 md:mb-1"
            />
            <img
              src={truststars}
              alt="trustpilot"
              className="w-40 sm:w-52 md:w-36 lg:w-48 h-auto"
            />
          </div>

          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white px-3 py-2 rounded-full mb-6 sm:mb-8 md:mb-4 lg:mb-5 shadow-lg">
            <svg
              className="w-4 h-4 sm:w-5 sm:h-5 text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                clip-rule="evenodd"
              />
            </svg>
            <span className="text-md font-medium">Activación Inmediata</span>
          </div>

          <h1 className="text-[2.35rem] md:text-[2rem] lg:text-[3.5rem] main-title font-black text-white leading-tight mb-3 md:mb-2 drop-shadow-2xl">
            {/* Version mobile : 3 lignes distinctes */}
            <div className="block sm:hidden text-white">
              <div className="whitespace-nowrap">Descubre lo mejor</div>
              <div className="whitespace-nowrap">
                de la <span className="text-orange-500">IPTV</span> en
              </div>
              <div className="whitespace-nowrap">
                España <span className="text-xl text-orange-200">🇪🇸</span>
              </div>
            </div>
            {/* Version desktop : 3 lignes */}
            <span className="hidden sm:inline text-white">
              Descubre lo mejor
              <br /> de la <span className="text-orange-500">IPTV</span> en
              <br /> España <span className="text-xl md:text-2xl lg:text-4xl text-orange-200">🇪🇸</span>
            </span>
          </h1>

          <div className="mb-6 sm:mb-8 md:mb-4 lg:mb-5 max-w-3xl">
            <p className="text-base md:text-sm lg:text-base xl:text-lg text-white leading-relaxed font-medium">
              Disfruta de tu tiempo con una excelente calidad de imagen hasta
              4K, en cualquier dispositivo, en cualquier momento y en cualquier
              lugar, con más de 79 000 canales, más de 249 000 VOD y un tiempo
              de disponibilidad del 100%.
            </p>
          </div>

          <div className="mb-6 sm:mb-8 md:mb-4 lg:mb-5">
            <div className="flex gap-3 md:gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60px"
                height="60px"
                className="md:w-[50px] md:h-[50px]"
                viewBox="0 0 1024 1024"
              >
                <path
                  fill="#FAFAFA"
                  d="M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9M200.4 208h624v395h-624zm228.3 608l8.1-37h150.3l8.1 37zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149z"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60px"
                height="60px"
                className="md:w-[50px] md:h-[50px]"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#FAFAFA"
                  d="M0 3h24v15h-4.046l2.698 2.063l-1.215 1.589L16.66 18H7.336l-4.771 3.652l-1.216-1.588L4.044 18H0zm2 2v11h20V5z"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60px"
                height="60px"
                className="md:w-[50px] md:h-[50px]"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#FAFAFA"
                  fillRule="evenodd"
                  d="M16.71 1.377a.75.75 0 0 0-.896-.703c-.5.1-2.132.506-3.42 1.794c-.658.658-1.022 1.488-1.22 2.244a7 7 0 0 0-.194 1.122l-.243-.104c-.693-.296-1.59-.64-2.61-.64c-1.092 0-2.642.444-3.922 1.7c-1.298 1.274-2.255 3.318-2.255 6.4c0 1.732.866 4.25 2.033 6.295c.59 1.033 1.285 1.995 2.035 2.704c.729.688 1.617 1.238 2.585 1.213c.72-.003 1.45-.286 2.017-.506l.05-.02c.654-.253 1.12-.424 1.511-.424c.374 0 .844.171 1.508.426l.049.018c.576.221 1.319.506 2.032.506c.539 0 1.162-.288 1.708-.627a9.6 9.6 0 0 0 1.796-1.476c1.137-1.182 2.217-2.871 2.175-4.679a.75.75 0 0 0-.428-.66a4.6 4.6 0 0 1-1.39-1.084c-.473-.543-.822-1.212-.844-1.988a5.55 5.55 0 0 1 .683-2.806c.422-.77.9-1.21 1.122-1.327a.75.75 0 0 0 .262-1.1c-.342-.48-.992-1.112-1.758-1.621c-.757-.504-1.744-.965-2.754-.945q-.265.007-.52.037c.37-.55.586-1.232.712-1.83a8.2 8.2 0 0 0 .177-1.919m-3.255 2.151c.541-.541 1.177-.883 1.704-1.094a7 7 0 0 1-.093.553c-.131.622-.337 1.142-.59 1.438c-.48.559-1.124 1.169-1.988 1.41c.028-.237.072-.49.138-.744c.155-.595.42-1.153.829-1.563m2.917 3.06c.565-.01 1.242.261 1.894.695c.344.228.648.48.89.712c-.357.358-.708.83-1.001 1.366a7.05 7.05 0 0 0-.867 3.57c.034 1.22.584 2.21 1.212 2.93c.46.527.98.934 1.43 1.21c-.127 1.095-.824 2.24-1.737 3.188a8 8 0 0 1-1.507 1.242c-.508.316-.824.401-.916.401c-.4 0-.888-.174-1.544-.425l-.08-.03c-.564-.217-1.286-.494-1.965-.494c-.7 0-1.418.279-1.98.497l-.072.028c-.648.25-1.127.424-1.537.424H8.57c-.376.012-.894-.212-1.52-.803c-.608-.575-1.217-1.403-1.763-2.358c-1.104-1.934-1.836-4.187-1.836-5.55c0-2.757.845-4.388 1.805-5.33c.978-.96 2.141-1.272 2.873-1.272c.695 0 1.353.235 2.02.52l.27.117c.238.103.485.21.709.295c.312.117.679.229 1.054.229s.746-.105 1.07-.22c.241-.085.505-.194.76-.299l.252-.104c.693-.282 1.382-.523 2.109-.538"
                  clipRule="evenodd"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60px"
                height="60px"
                className="md:w-[50px] md:h-[50px]"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#FAFAFA"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M6.5 9.5a5.5 5.5 0 1 1 11 0V16c0 1.414 0 2.121-.44 2.56c-.439.44-1.146.44-2.56.44h-5c-1.414 0-2.121 0-2.56-.44c-.44-.439-.44-1.146-.44-2.56zM20 11v6m-5 2v3m-6-3v3M4 11v6m6-13L8.5 2M14 4l1.5-2m-9 8h11"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60px"
                height="60px"
                className="md:w-[50px] md:h-[50px]"
                viewBox="0 0 256 256"
              >
                <path
                  fill="#FAFAFA"
                  d="M208 136h-80a8 8 0 0 0-8 8v57.45a8 8 0 0 0 6.57 7.88l80 14.54a7.6 7.6 0 0 0 1.43.13a8 8 0 0 0 8-8v-72a8 8 0 0 0-8-8m-8 70.41l-64-11.63V152h64ZM96 136H32a8 8 0 0 0-8 8v40a8 8 0 0 0 6.57 7.87l64 11.64a8.5 8.5 0 0 0 1.43.13a8 8 0 0 0 8-8V144a8 8 0 0 0-8-8m-8 50.05l-48-8.73V152h48ZM213.13 33.86a8 8 0 0 0-6.56-1.73l-80 14.55a8 8 0 0 0-6.57 7.87V112a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8V40a8 8 0 0 0-2.87-6.14M200 104h-64V61.22l64-11.63Zm-98.87-49.78a8 8 0 0 0-6.56-1.73l-64 11.64A8 8 0 0 0 24 72v40a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8V60.36a8 8 0 0 0-2.87-6.14M88 104H40V78.68L88 70Z"
                ></path>
              </svg>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-2 lg:gap-3 items-start sm:items-center">
            <a
              href="#pricing"
              className="w-auto sm:w-auto bg-white  hover:brightness-125 text-gray-800 font-black py-3 md:py-2.5 px-4 sm:px-6 md:px-4 lg:px-5 rounded-xl text-base md:text-sm lg:text-base transition-all duration-700 transform shadow-2xl hover:shadow-gray-500/30 hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center border border-gray-200 hover:border-gray-300 cursor-pointer"
            >
              Ordenar ahora
            </a>
            <div className="flex items-center gap-2 text-white/80">
              <svg
                className="w-3 h-3 sm:w-4 sm:h-4 text-emerald-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-xs font-medium">
                Activación instantánea
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
